import { render, staticRenderFns } from "./commentFile.vue?vue&type=template&id=041cefb5&scoped=true"
import script from "./commentFile.vue?vue&type=script&lang=js"
export * from "./commentFile.vue?vue&type=script&lang=js"
import style0 from "./commentFile.vue?vue&type=style&index=0&id=041cefb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cefb5",
  null
  
)

export default component.exports